var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seat-state-wrapper"},_vm._l((_vm.floorPlanStats),function(data){return _c('div',{key:data.label,staticClass:"seat-state"},[_c('div',{staticClass:"state-logo",style:(data.style)}),_c('span',[_vm._v(_vm._s(data.label))]),_c('p',{staticClass:"count"},[_vm._v(_vm._s(data.count()))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }